import {useState} from 'react'

import {Combobox, useCombobox} from '@mantine/core'
import {useTranslation} from 'react-i18next'
import {Label} from 'reactstrap'
import SimpleBar from 'simplebar-react'

import Icon from '../../icon'

const DropDownGroups = ({
  required,
  name,
  subtitle,
  label,
  options,
  searchable,
  onChange,
  value,
  children
}) => {
  const {t} = useTranslation()
  const [currentValue, setCurrentValue] = useState(null)
  const [search, setSearch] = useState('')
  const combobox = useCombobox({
    onDropdownClose: () => {
      combobox.resetSelectedOption()
      combobox.focusTarget()
      setSearch('')
    },
    onDropdownOpen: () => {
      searchable && combobox.focusSearchInput()
    }
  })

  const alloptions = options.reduce(
    (acc, group) => [...acc, ...group.options],
    []
  )

  const shouldFilterOptions = alloptions.every(item => item !== search)

  const filteredGroups = options.map(group => {
    const filteredOptions = shouldFilterOptions
      ? group.options.filter(item =>
          item?.label?.toLowerCase().includes(search.toLowerCase().trim())
        )
      : group.options

    return {...group, options: filteredOptions}
  })

  const totalOptions = filteredGroups.reduce(
    (acc, group) => acc + group.options.length,
    0
  )

  const groups = filteredGroups.map((group, index) => {
    const options = group.options.map((item, index2) => (
      <Combobox.Option
        value={item?.value}
        key={index2}
        active={item?.value === currentValue}>
        {item.icon && (
          <Icon
            className={item?.value === currentValue && 'combo-box-option-icon'}
            icon={item.icon}
            size={[15, 15]}
            style={{marginRight: 6}}
          />
        )}
        {item?.label}
      </Combobox.Option>
    ))

    return (
      <Combobox.Group
        label={group?.label?.toUpperCase()}
        key={index}
        className={group.divider && 'combo-box-option-divider'}>
        <div />
        {options}
      </Combobox.Group>
    )
  })

  const filteredGroupss = groups.filter(e => e.props.children[1].length > 0)

  const handleKeyDown = event => {
    if (currentValue?.length === 1 && event.key === 'Enter') {
      setCurrentValue(currentValue[0].value)
      combobox.closeDropdown()
    }
  }

  return (
    <div className="mt-2">
      {label && (
        <Label className="heading_4" htmlFor={name}>
          {label}
          {required && <span className="text-danger"> *</span>}
        </Label>
      )}
      <Combobox
        store={combobox}
        withinPortal={false}
        onOptionSubmit={val => {
          setCurrentValue(val)
          onChange(val)
          combobox.closeDropdown()
          combobox.updateSelectedOptionIndex('active')
        }}
        position="bottom"
        middlewares={{flip: false, shift: false}}>
        <Combobox.Target onClick={() => combobox.toggleDropdown()}>
          {children}
        </Combobox.Target>

        <Combobox.Dropdown>
          {searchable && (
            <Combobox.Search
              onKeyDown={e => handleKeyDown(e)}
              rightSectionPointerEvents={value === null ? 'none' : 'all'}
              value={search}
              onChange={event => setSearch(event.currentTarget.value)}
              placeholder={`${t('SEARCH')}...`}
              rightSection={
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginRight: 24
                  }}>
                  {search !== '' ? (
                    <div
                      onMouseDown={event => event.preventDefault()}
                      onClick={() => setSearch('')}
                      aria-label="Clear value">
                      <Icon icon="closeIcon" size={[18, 18]} />
                    </div>
                  ) : (
                    <Icon icon="searchIcon" size={[15, 15]} />
                  )}
                </div>
              }
            />
          )}
          <SimpleBar style={{maxHeight: '320px'}} autoHide={false}>
            <Combobox.Options>
              {totalOptions > 0 ? (
                filteredGroupss
              ) : (
                <Combobox.Empty>{t('NO_RESULTS_FOUND')}</Combobox.Empty>
              )}
            </Combobox.Options>
          </SimpleBar>
        </Combobox.Dropdown>
      </Combobox>
      {subtitle && (
        <div style={{marginTop: 5}} className="bodyText_11 input_subtitle_text">
          {subtitle}
        </div>
      )}
    </div>
  )
}

export default DropDownGroups
